import { isStringNullOrWhiteSpace } from 'owa-localize';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemIdAttachment from 'owa-service/lib/contract/ItemIdAttachment';

export const FILE_ATTACHMENT_TYPE: string = 'FileAttachment:#Exchange';
export const ITEM_ATTACHMENT_TYPE: string = 'ItemAttachment:#Exchange';
export const ITEM_ID_ATTACHMENT_TYPE: string = 'ItemIdAttachment:#Exchange';
export const REFERENCE_ATTACHMENT_TYPE: string = 'ReferenceAttachment:#Exchange';

export interface AttachmentDetails {
    id: string;
    name: string;
    contentType?: string;
    size?: number;
    attachmentType: TypeOfAttachment;
    isInline: boolean;
    url?: string;
}

// Order matters
export enum TypeOfAttachment {
    File = 0,
    Item = 1,
    Cloud = 2,
}

export const createAttachmentDetails = (attachments: AttachmentType[]): AttachmentDetails[] => {
    return attachments.map(
        attachment =>
            <AttachmentDetails>{
                id: getIdOrUrl(attachment),
                name: attachment.Name,
                contentType: attachment.ContentType,
                size: attachment.Size,
                attachmentType: getTypeOfAttachment(attachment),
                isInline: attachment.IsInline || false,
            }
    );
};

function getIdOrUrl(attachment: AttachmentType): string {
    return attachment.__type === REFERENCE_ATTACHMENT_TYPE
        ? attachment.AttachmentOriginalUrl
        : attachment.AttachmentId.Id;
}

export function getTypeOfAttachment(attachment: AttachmentType): TypeOfAttachment {
    switch (attachment.__type) {
        case FILE_ATTACHMENT_TYPE:
            return TypeOfAttachment.File;
        case ITEM_ATTACHMENT_TYPE:
            return TypeOfAttachment.Item;
        case REFERENCE_ATTACHMENT_TYPE:
            return TypeOfAttachment.Cloud;
        case ITEM_ID_ATTACHMENT_TYPE:
            const itemIdAttachment = attachment as ItemIdAttachment;
            if (!isStringNullOrWhiteSpace(itemIdAttachment.AttachmentIdToAttach)) {
                return TypeOfAttachment.File;
            }

            return TypeOfAttachment.Item;
        default:
            throw new Error(`Invalid type of attachment ${attachment.__type}`);
    }
}
